import { query } from 'src/utils/request';

// 单据列表
export const getDinnerFeeList = async data => {
  return query('/zlb/api/search/page/web/night-meal-pay', {
    method: 'POST',
    data,
  });
};
